import { PlanMeasureKey } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/types";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";
import { Semantics as SidesporSemantics } from "shared/theme/sidespor/theme/themeSemantics";
import { Semantics } from "shared/utils/semantics";

type Subset<T, U extends T> = U;

export function getSemanticsForMeasureCard(
  recentlyUpdated: boolean,
  isMuted: boolean,
  measureColumnKey: PlanMeasureKey,
): Subset<Semantics, "alarm" | "warning" | "neutral"> {
  if (recentlyUpdated) return "warning";

  if (measureColumnKey === "noCoverage" && !isMuted) return "alarm";

  return "neutral";
}

export function sidesporSemanticsForEventType(
  eventType: CombinedHistoryResponse["type"]["type"],
  isClosedOrWithdrawn: boolean,
): Subset<SidesporSemantics, "ghost" | "alarm" | "neutral"> {
  if (isClosedOrWithdrawn) return "ghost";

  switch (eventType) {
    case "INFRASTRUCTURE_STRETCH_CLOSED":
    case "INFRASTRUCTURE_STRETCH_PARTIALLY_CLOSED":
    case "TRAIN_STOPPED":
    case "TRAIN_CANCELLED":
      return "alarm";

    case "TRAIN_CAPACITY_REDUCED":
    case "TRAIN_MISSING_PRODUCT":
    case "TRAIN_DELAY_EXPECTED":
    case "TRAIN_CAPACITY_INCREASED":
    case "TRAIN_DELAYED":
    case "TRAIN_LATE_TO_TRACK":
    case "TRAIN_NOT_STOPPING_AT_STATION":
    case "TRAIN_STOPPING_EXTRA_AT_STATION":
    case "TRAIN_CLOSED_SET":
    case "TRAIN_CHANGED_ROUTE":
    case "TRAIN_GENERAL":
    case "TRAIN_GROUP_TRAVEL":
    case "TRAIN_WHEELCHAIR_PASSENGER":
    case "TRAIN_REDUCED_MOBILITY_PASSENGER":
    case "TRAIN_VISUALLY_IMPAIRED_PASSENGER":
    case "STATION_THREAT_LEVEL":
    case "STATION_SALES_CHANNEL_REDUCED":
    case "STATION_DIFFICULT_CUSTOMER":
    case "STATION_WANTED_PERSON":
    case "STATION_ELEVATOR_FAULT":
    case "STATION_TRACK_MONITOR_FAULT":
    case "STATION_ARRI_AND_DEPARTURE_MONITOR_FAULT":
    case "STATION_SPEAKER_FAULT":
    case "STATION_WHEELCHAIR_RAMP_FAULT":
    case "STATION_GENERAL_INFO":
    case "STATION_GENERAL_WARNING":
    case "STATION_PLATFORM_FAULT":
    case "STATION_ALL_SALES_CHANNELS_DOWN":
    case "STATION_APP_SALES_CHANNEL_DOWN":
    case "STATION_MOBILE_TERMINALS_SALES_CHANNEL_DOWN":
    case "STATION_TICKET_MACHINE_DOWN":
    case "STATION_TICKET_IDATOR_DOWN":
    case "STATION_DEPOSIT_MACHINE_DOWN":
    case "STATION_MAIN_MONITOR_FAULT":
    case "STATION_PLATFORM_SLIPPERY":
    case "STATION_PARKING_ISSUE":
    case "STATION_ENTRANCE_CHANGED":
    case "STATION_WAITING_ROOM_CLOSED":
    case "STATION_CLOSED_FOR_PASSENGERS":
    case "STATION_DROPS_EVACUATION":
    case "STATION_UNKNOWN_EVENT":
    case "INFRASTRUCTURE_SLOW_DRIVING":
    case "INFRASTRUCTURE_PLANNED_MAINTENANCE":
    case "INFRASTRUCTURE_GENERAL_INFO":
    case "INFRASTRUCTURE_GENERAL_WARNING":
    case "GLOBAL_GENERAL_WARNING":
    case "GLOBAL_INTERNAL_INFO":
    case "GLOBAL_UNKNOWN_EVENT":
      return "neutral";
  }
}
